import { getUserFromToken } from './functions.ts';


export const getPositions = async () => {
    try {
        const response = await fetch('https://www.fbxchange.com/ReactPHP/loadData.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                method: 'getPositionData',
            }).toString()
        });

        const data = await response.json();
        return data;

    } catch (error) {
        console.error('Data Error:', error);
        return null; // Return null in case of an error
    }
}

export const getCountry = async () => {
    try {
        const response = await fetch('https://www.fbxchange.com/ReactPHP/loadData.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                method: 'getCountryData',
            }).toString()
        });

        const data = await response.json();
        return data;

    } catch (error) {
        console.error('Data Error:', error);
        return null; // Return null in case of an error
    }
}

export const getSchools = async () => {
    try {
        const response = await fetch('https://www.fbxchange.com/ReactPHP/reactSearch.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                method: 'getSchools',
            }).toString()
        });

        const data = await response.json();
        return data;

    } catch (error) {
        console.error('Failed to fetch token:', error);
        return null; // Return null in case of an error
    }
}

export const getAgents = async () => {
    try {
        const response = await fetch('https://www.fbxchange.com/ReactPHP/loadData.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                method: 'getAgents',
            }).toString()
        });

        const data = await response.json();
        return data;

    } catch (error) {
        console.error('Failed to fetch token:', error);
        return null; // Return null in case of an error
    }
}


export const getEvents = async () => {
    try {
        const response = await fetch('https://www.fbxchange.com/ReactPHP/loadData.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                method: 'getEvents',
            }).toString()
        });

        const data = await response.json();
        // Format data as a hardcoded array
        //   const formattedData = data.map((item) => ({
        //     Team: item.Team,
        //     Team_Name: item.Team_Name,
        //     Affiliation: item.Affiliation,
        // }));

        // // Log formatted data for copying
        // console.log(JSON.stringify(formattedData, null, 4));
        return data; // Return the fetched data
    } catch (error) {
        console.error('Failed to fetch events:', error);
        return null; // Return null in case of an error
    }
};

const eventSearch = [
    {
        "Team": "STAR",
        "Team_Name": "All Star Gm Misc",
        "Affiliation": "ASGm"
    },
    {
        "Team": "UFL24",
        "Team_Name": "ALL-STAR UFL24",
        "Affiliation": "ASGm"
    },
    {
        "Team": "CFL",
        "Team_Name": "ALL-STAR, CFL",
        "Affiliation": "ASGm"
    },
    {
        "Team": "CIS",
        "Team_Name": "ALL-STAR, CIS",
        "Affiliation": "ASGm"
    },
    {
        "Team": "NCAA",
        "Team_Name": "ALL-STAR, NCAA",
        "Affiliation": "ASGm"
    },
    {
        "Team": "BSNC",
        "Team_Name": "BSN Collegiate Showcase",
        "Affiliation": "ASGm"
    },
    {
        "Team": "CACT",
        "Team_Name": "Cactus Bowl",
        "Affiliation": "ASGm"
    },
    {
        "Team": "ABG",
        "Team_Name": "American Bowl Game",
        "Affiliation": "ASGm"
    },
    {
        "Team": "EESG",
        "Team_Name": "Casino Del Sol All Star Game - Tucson",
        "Affiliation": "ASGm"
    },
    {
        "Team": "CFLRM",
        "Team_Name": "CFL Eastern Regional Combine",
        "Affiliation": "ASGm"
    },
    {
        "Team": "CFLFA",
        "Team_Name": "CFL FA Combine",
        "Affiliation": "ASGm"
    },
    {
        "Team": "CFLGC",
        "Team_Name": "CFL IAGF Combines",
        "Affiliation": "ASGm"
    },
    {
        "Team": "CFLE",
        "Team_Name": "CFL National Combine",
        "Affiliation": "ASGm"
    },
    {
        "Team": "CFLRT",
        "Team_Name": "CFL Ontario Regional Combine",
        "Affiliation": "ASGm"
    },
    {
        "Team": "CFLRC",
        "Team_Name": "CFL Regional Combines",
        "Affiliation": "ASGm"
    },
    {
        "Team": "CFLRE",
        "Team_Name": "CFL Western Regional Combine",
        "Affiliation": "ASGm"
    },
    {
        "Team": "SCCAS",
        "Team_Name": "College All Star Bowl(S.C.)",
        "Affiliation": "ASGm"
    },
    {
        "Team": "TXNA",
        "Team_Name": "College Gridiron Showcase",
        "Affiliation": "ASGm"
    },
    {
        "Team": "DFord",
        "Team_Name": "D.Forde FA Camp",
        "Affiliation": "ASGm"
    },
    {
        "Team": "HBCU",
        "Team_Name": "DREAM Bowl",
        "Affiliation": "ASGm"
    },
    {
        "Team": "EOJRS",
        "Team_Name": "Early Out Juniors",
        "Affiliation": "ASGm"
    },
    {
        "Team": "EACB",
        "Team_Name": "East Coast Bowl Game",
        "Affiliation": "ASGm"
    },
    {
        "Team": "EWSH",
        "Team_Name": "East West Shrine Bowl",
        "Affiliation": "ASGm"
    },
    {
        "Team": "EVENT",
        "Team_Name": "EVENT",
        "Affiliation": "ASGm"
    },
    {
        "Team": "WORLD",
        "Team_Name": "FBC U20 World All Star Team",
        "Affiliation": "ASGm"
    },
    {
        "Team": "FCSSB",
        "Team_Name": "FCS Bowl",
        "Affiliation": "ASGm"
    },
    {
        "Team": "GRID",
        "Team_Name": "GRID - FB Camps",
        "Affiliation": "ASGm"
    },
    {
        "Team": "HBCUE",
        "Team_Name": "HBCU Legacy Bowl",
        "Affiliation": "ASGm"
    },
    {
        "Team": "PPS",
        "Team_Name": "HUB-Football",
        "Affiliation": "ASGm"
    },
    {
        "Team": "HBUSA",
        "Team_Name": "Hula Bowl",
        "Affiliation": "ASGm"
    },
    {
        "Team": "HBCUC",
        "Team_Name": "HBCU & IPP Showcase",
        "Affiliation": "ASGm"
    },
    {
        "Team": "MOHB",
        "Team_Name": "Medal of Honor Bowl All Star",
        "Affiliation": "ASGm"
    },
    {
        "Team": "MEXDR",
        "Team_Name": "MEXICO LFA DRAFT OF Canadians",
        "Affiliation": "ASGm"
    },
    {
        "Team": "MPL",
        "Team_Name": "MISC Pro Leagues",
        "Affiliation": "ASGm"
    },
    {
        "Team": "NBG",
        "Team_Name": "National Bowl Game",
        "Affiliation": "ASGm"
    },
    {
        "Team": "NFLS",
        "Team_Name": "NFL All-Pro Team",
        "Affiliation": "ASGm"
    },
    {
        "Team": "NFLIC",
        "Team_Name": "NFL International Combines",
        "Affiliation": "ASGm"
    },
    {
        "Team": "NFLI",
        "Team_Name": "NFL International Player Pathway program",
        "Affiliation": "ASGm"
    },
    {
        "Team": "NFLE",
        "Team_Name": "NFL National Combine-Indy",
        "Affiliation": "ASGm"
    },
    {
        "Team": "NFLRC",
        "Team_Name": "NFL Regional Combines",
        "Affiliation": "ASGm"
    },
    {
        "Team": "NFLPA",
        "Team_Name": "NFLPA Collegiate Bowl",
        "Affiliation": "ASGm"
    },
    {
        "Team": "PASC",
        "Team_Name": "Players All Star Classic",
        "Affiliation": "ASGm"
    },
    {
        "Team": "PODY",
        "Team_Name": "Podyum All-Star Bowl",
        "Affiliation": "ASGm"
    },
    {
        "Team": "ProDay",
        "Team_Name": "ProDay",
        "Affiliation": "ASGm"
    },
    {
        "Team": "RAYCO",
        "Team_Name": "Raycom All Star Classic",
        "Affiliation": "ASGm"
    },
    {
        "Team": "SRBW",
        "Team_Name": "Senior Bowl",
        "Affiliation": "ASGm"
    },
    {
        "Team": "TSL",
        "Team_Name": "The Spring League",
        "Affiliation": "ASGm"
    },
    {
        "Team": "Trop",
        "Team_Name": "Tropical Bowl All-Star",
        "Affiliation": "ASGm"
    },
    {
        "Team": "GTEAM",
        "Team_Name": "USA-CDN Players Overseas",
        "Affiliation": "ASGm"
    },
    {
        "Team": "CISQB",
        "Team_Name": "USport-CFL QB Internship",
        "Affiliation": "ASGm"
    },
    {
        "Team": "CISEW",
        "Team_Name": "USports East West Bowl",
        "Affiliation": "ASGm"
    },
    {
        "Team": "YCF",
        "Team_Name": "Your Call Football",
        "Affiliation": "ASGm"
    }
];



/// default data

const heightStringFull: string = "5045,5046,5047,5050,5051,5052,5053,5054,5055,5056,5057,5060,5061,5062,5063,5064,5065,5066,5067,5070,5071,5072,5073,5074,5075,5076,5077,5080,5081,5082,5083,5084,5085,5086,5087,5090,5091,5092,5093,5094,5095,5096,5097,5100,5101,5102,5103,5104,5105,5106,5107,5110,5111,5112,5113,5114,5115,5116,5117,6000,6001,6002,6003,6004,6005,6006,6007,6010,6011,6012,6013,6014,6015,6016,6017,6020,6021,6022,6023,6024,6025,6026,6027,6030,6031,6032,6033,6034,6035,6036,6037,6040,6041,6042,6043,6044,6045,6046,6047,6050,6051,6052,6053,6054,6055,6056,6057,6060,6061,6062,6063,6064,6065,6066,6067,6070,6071,6072,6073,6074,6076,6077,6080,6081,6082,6083,6084,6085,6087,6091,6092,6094,6095,6096,6097,6100,6101,6102,6103,6104,6105,6106,6107,6110,6111,6112,6113,6114,6115,6116,6117,7000,7001,7002,7003,7004,7005,7006,7007,7010,7011,7012,7013,7014,7015,7016,7017,7020,7021,7022,7023,7024,7025,7026,7027,7030,7031,7032,7033,7034,7035,7036,7037,7040,7041,7042,7043,7044,7045,7046,7047,7050,7051,7052,7053,7054,7055,7056,7057,7060,7061,7062,7063,7064,7065,7066,7067,7070,7071,7072,7073,7074,7075,7076,7077,7080,7081,7082,7083,7084,7085,7086,7087,7090,7091,7092,7093,7094,7095,7096,7097,7100,7101,7102,7103,7104,7105,7106,7107,7110,7111,7112,7113,7114,7115,7116,7117";
const heightArray: string[] = heightStringFull.split(',');
const heightOptions = [ // First record with custom label and value
    ...heightArray.map((height) => ({
        label: height, // Display the height as is
        value: height, // Use the height itself as the value
    }))
];

export { heightOptions }

const USStates: any = [
    { abbreviation: "AL", name: "Alabama" },
    { abbreviation: "AK", name: "Alaska" },
    { abbreviation: "AZ", name: "Arizona" },
    { abbreviation: "AR", name: "Arkansas" },
    { abbreviation: "CA", name: "California" },
    { abbreviation: "CO", name: "Colorado" },
    { abbreviation: "CT", name: "Connecticut" },
    { abbreviation: "DE", name: "Delaware" },
    { abbreviation: "FL", name: "Florida" },
    { abbreviation: "GA", name: "Georgia" },
    { abbreviation: "HI", name: "Hawaii" },
    { abbreviation: "ID", name: "Idaho" },
    { abbreviation: "IL", name: "Illinois" },
    { abbreviation: "IN", name: "Indiana" },
    { abbreviation: "IA", name: "Iowa" },
    { abbreviation: "KS", name: "Kansas" },
    { abbreviation: "KY", name: "Kentucky" },
    { abbreviation: "LA", name: "Louisiana" },
    { abbreviation: "ME", name: "Maine" },
    { abbreviation: "MD", name: "Maryland" },
    { abbreviation: "MA", name: "Massachusetts" },
    { abbreviation: "MI", name: "Michigan" },
    { abbreviation: "MN", name: "Minnesota" },
    { abbreviation: "MS", name: "Mississippi" },
    { abbreviation: "MO", name: "Missouri" },
    { abbreviation: "MT", name: "Montana" },
    { abbreviation: "NE", name: "Nebraska" },
    { abbreviation: "NV", name: "Nevada" },
    { abbreviation: "NH", name: "New Hampshire" },
    { abbreviation: "NJ", name: "New Jersey" },
    { abbreviation: "NM", name: "New Mexico" },
    { abbreviation: "NY", name: "New York" },
    { abbreviation: "NC", name: "North Carolina" },
    { abbreviation: "ND", name: "North Dakota" },
    { abbreviation: "OH", name: "Ohio" },
    { abbreviation: "OK", name: "Oklahoma" },
    { abbreviation: "OR", name: "Oregon" },
    { abbreviation: "PA", name: "Pennsylvania" },
    { abbreviation: "RI", name: "Rhode Island" },
    { abbreviation: "SC", name: "South Carolina" },
    { abbreviation: "SD", name: "South Dakota" },
    { abbreviation: "TN", name: "Tennessee" },
    { abbreviation: "TX", name: "Texas" },
    { abbreviation: "UT", name: "Utah" },
    { abbreviation: "VT", name: "Vermont" },
    { abbreviation: "VA", name: "Virginia" },
    { abbreviation: "WA", name: "Washington" },
    { abbreviation: "WV", name: "West Virginia" },
    { abbreviation: "WI", name: "Wisconsin" },
    { abbreviation: "WY", name: "Wyoming" },
    { abbreviation: "AB", name: "Alberta" },
    { abbreviation: "BC", name: "British Columbia" },
    { abbreviation: "MB", name: "Manitoba" },
    { abbreviation: "NB", name: "New Brunswick" },
    { abbreviation: "NL", name: "Newfoundland and Labrador" },
    { abbreviation: "NS", name: "Nova Scotia" },
    { abbreviation: "ON", name: "Ontario" },
    { abbreviation: "PE", name: "Prince Edward Island" },
    { abbreviation: "QC", name: "Quebec" },
    { abbreviation: "SK", name: "Saskatchewan" },
    { abbreviation: "NT", name: "Northwest Territories" },
    { abbreviation: "NU", name: "Nunavut" },
    { abbreviation: "YT", name: "Yukon" }
];

export { USStates }

const schoolLocations: any = [
    { abbreviation: "USA", name: "USA Schools" },
    { abbreviation: "CANADA", name: "Canadian Schools " },
    { abbreviation: "-", name: "Non USA/CAN Schools/Team " }
]

export { schoolLocations }

const genPos: any = [{ "GeneralPos": "QB", "DescriptionOfPos": "QB", "title": "Quarterback" }, { "GeneralPos": "WR", "DescriptionOfPos": "WR, TE, FL, HT, SB", "title": "Wide Receiver" }, { "GeneralPos": "RB", "DescriptionOfPos": "RB, FB", "title": "Running Back" }, { "GeneralPos": "OL", "DescriptionOfPos": "OT, OG, OC, OL", "title": "O-Line" }, { "GeneralPos": "DL", "DescriptionOfPos": "DT, DE, NT, DL", "title": "D-Line" }, { "GeneralPos": "LB", "DescriptionOfPos": "OB, IB, LB, WB, SB", "title": "Linebacker" }, { "GeneralPos": "DB", "DescriptionOfPos": "DC, SS, FS, HB, S, DB", "title": "Defensive Back" }, { "GeneralPos": "ST", "DescriptionOfPos": "LS, H, PR, KR, RS, K, P, PK", "title": "Special Teams" }];

export { genPos };

const cflObject: any = [{ "Team": "BCL", "Team_Name": "B.C. Lions", "Affiliation": "CFL" }, { "Team": "CAL", "Team_Name": "Calgary Stampeders", "Affiliation": "CFL" }, { "Team": "EDM", "Team_Name": "Edmonton Elks", "Affiliation": "CFL" }, { "Team": "HAM", "Team_Name": "Hamilton Tiger-Cats", "Affiliation": "CFL" }, { "Team": "MTL", "Team_Name": "Montreal Alouettes", "Affiliation": "CFL" }, { "Team": "OTT", "Team_Name": "Ottawa REDBLACKS", "Affiliation": "CFL" }, { "Team": "SRR", "Team_Name": "Saskatchewan Roughriders", "Affiliation": "CFL" }, { "Team": "TOR", "Team_Name": "Toronto Argos", "Affiliation": "CFL" }, { "Team": "WNP", "Team_Name": "Winnipeg Blue Bombers", "Affiliation": "CFL" }];

const nflObject: any = [{ "Team": "ARZ", "Team_Name": "Arizona Cardinals", "Affiliation": "NFL" }, { "Team": "ATL", "Team_Name": "Atlanta Falcons", "Affiliation": "NFL" }, { "Team": "BLT", "Team_Name": "Baltimore Ravens", "Affiliation": "NFL" }, { "Team": "BUF", "Team_Name": "Buffalo Bills", "Affiliation": "NFL" }, { "Team": "CAR", "Team_Name": "Carolina Panthers", "Affiliation": "NFL" }, { "Team": "CHI", "Team_Name": "Chicago Bears", "Affiliation": "NFL" }, { "Team": "CIN", "Team_Name": "Cincinnati Bengals", "Affiliation": "NFL" }, { "Team": "CLV", "Team_Name": "Cleveland Browns", "Affiliation": "NFL" }, { "Team": "DAL", "Team_Name": "Dallas Cowboys", "Affiliation": "NFL" }, { "Team": "DEN", "Team_Name": "Denver Broncos", "Affiliation": "NFL" }, { "Team": "DET", "Team_Name": "Detroit Lions", "Affiliation": "NFL" }, { "Team": "GRB", "Team_Name": "Green Bay Packers", "Affiliation": "NFL" }, { "Team": "HST", "Team_Name": "Houston Texans", "Affiliation": "NFL" }, { "Team": "IND", "Team_Name": "Indianapolis Colts", "Affiliation": "NFL" }, { "Team": "JAX", "Team_Name": "Jacksonville Jaguars", "Affiliation": "NFL" }, { "Team": "KAN", "Team_Name": "Kansas City Chiefs", "Affiliation": "NFL" }, { "Team": "OAK", "Team_Name": "Las Vegas Raiders", "Affiliation": "NFL" }, { "Team": "SDC", "Team_Name": "Los Angeles Chargers", "Affiliation": "NFL" }, { "Team": "RAM", "Team_Name": "Los Angeles Rams", "Affiliation": "NFL" }, { "Team": "MIA", "Team_Name": "Miami Dolphins", "Affiliation": "NFL" }, { "Team": "MIN", "Team_Name": "Minnesota Vikings", "Affiliation": "NFL" }, { "Team": "NEP", "Team_Name": "New England Patriots", "Affiliation": "NFL" }, { "Team": "NEO", "Team_Name": "New Orleans Saints", "Affiliation": "NFL" }, { "Team": "NYG", "Team_Name": "New York Giants", "Affiliation": "NFL" }, { "Team": "NYJ", "Team_Name": "New York Jets", "Affiliation": "NFL" }, { "Team": "PHI", "Team_Name": "Philadelphia Eagles", "Affiliation": "NFL" }, { "Team": "PIT", "Team_Name": "Pittsburgh Steelers", "Affiliation": "NFL" }, { "Team": "SFN", "Team_Name": "San Francisco 49ers", "Affiliation": "NFL" }, { "Team": "SEA", "Team_Name": "Seattle Seahawks", "Affiliation": "NFL" }, { "Team": "TAM", "Team_Name": "Tampa Bay Buccaneers", "Affiliation": "NFL" }, { "Team": "TEN", "Team_Name": "Tennessee Titans", "Affiliation": "NFL" }, { "Team": "WAS", "Team_Name": "Washington Commanders", "Affiliation": "NFL" }];

const xfl23Object: any = [{ "Team": "ARL", "Team_Name": "Arlington RENEGADES", "Affiliation": "XFL23" }, { "Team": "WDC", "Team_Name": "D.C. DEFENDERS", "Affiliation": "XFL23" }, { "Team": "HOU", "Team_Name": "Houston ROUGHNECKS", "Affiliation": "XFL23" }, { "Team": "ORX", "Team_Name": "Orlando GUARDIANS", "Affiliation": "XFL23" }, { "Team": "SAX", "Team_Name": "San Antonio BRAHMAS", "Affiliation": "XFL23" }, { "Team": "SXE", "Team_Name": "Seattle SEA DRAGONS", "Affiliation": "XFL23" }, { "Team": "STL", "Team_Name": "St. Louis BATTLEHAWKS", "Affiliation": "XFL23" }, { "Team": "LAS", "Team_Name": "Vegas VIPERS", "Affiliation": "XFL23" },];

const usflObject: any = [{ "Team": "UBST", "Team_Name": "Birmingham Stallions", "Affiliation": "USFL" }, { "Team": "UHGA", "Team_Name": "Houston Gamblers", "Affiliation": "USFL" }, { "Team": "UTBB", "Team_Name": "Memphis Showboats", "Affiliation": "USFL" }, { "Team": "UMPA", "Team_Name": "Michigan Panthers", "Affiliation": "USFL" }, { "Team": "UNJG", "Team_Name": "New Jersey Generals", "Affiliation": "USFL" }, { "Team": "UNOB", "Team_Name": "New Orleans Breakers", "Affiliation": "USFL" }, { "Team": "UPST", "Team_Name": "Philadelphia Stars", "Affiliation": "USFL" }, { "Team": "UPMA", "Team_Name": "Pittsburgh Maulers", "Affiliation": "USFL" }];

const xflObject: any = [{ "Team": "XDA", "Team_Name": "x-DALLAS Renegades", "Affiliation": "XFL" }, { "Team": "XHR", "Team_Name": "x-HOUSTON Roughnecks", "Affiliation": "XFL" }, { "Team": "XLW", "Team_Name": "x-LOS ANGELES Wildcats", "Affiliation": "XFL" }, { "Team": "XNG", "Team_Name": "x-NEW YORK Guardians", "Affiliation": "XFL" }, { "Team": "XSE", "Team_Name": "x-SEATTLE Dragons", "Affiliation": "XFL" }, { "Team": "XSL", "Team_Name": "x-ST. LOUIS Battlehawks", "Affiliation": "XFL" }, { "Team": "XTV", "Team_Name": "x-TAMPA BAY Vipers", "Affiliation": "XFL" }, { "Team": "XDC", "Team_Name": "x-WASHINGTON DC Defenders", "Affiliation": "XFL" }, { "Team": "XT9", "Team_Name": "XFL TEAM 9", "Affiliation": "XFL" }];

const uflObject: any = [{ "Team": "LVL", "Team_Name": "x - Las Vegas LOCOMOTIVES", "Affiliation": "UFL" }, { "Team": "OMA", "Team_Name": "x - Omaha NIGHTHAWKS", "Affiliation": "UFL" }, { "Team": "CML", "Team_Name": "x - Sacramento MOUNTAIN LIONS", "Affiliation": "UFL" }, { "Team": "VIR", "Team_Name": "x - Virginia DESTROYERS", "Affiliation": "UFL" }, { "Team": "FLT", "Team_Name": "xx - Florida TUSKERS", "Affiliation": "UFL" }, { "Team": "NYS", "Team_Name": "xx - Hartford COLONIALS", "Affiliation": "UFL" }];

const aafObject: any = [{ "Team": "APH", "Team_Name": "Arizona HOTSHOTS", "Affiliation": "AAF" }, { "Team": "AAT", "Team_Name": "Atlanta LEGENDS", "Affiliation": "AAF" }, { "Team": "ABR", "Team_Name": "Birmingham IRON", "Affiliation": "AAF" }, { "Team": "AME", "Team_Name": "Memphis EXPRESS", "Affiliation": "AAF" }, { "Team": "AOR", "Team_Name": "Orlando APOLLOS", "Affiliation": "AAF" }, { "Team": "ASL", "Team_Name": "Salt Lake City STALLIONS", "Affiliation": "AAF" }, { "Team": "AAN", "Team_Name": "San Antonio COMMANDERS", "Affiliation": "AAF" }, { "Team": "ASD", "Team_Name": "San Diego FLEET", "Affiliation": "AAF" }];

const mlfbObject: any = [{ "Team": "CAM", "Team_Name": "Campo", "Affiliation": "MLFB" }, { "Team": "CLS", "Team_Name": "Collins", "Affiliation": "MLFB" }, { "Team": "COT", "Team_Name": "Cottrel", "Affiliation": "MLFB" }, { "Team": "FOD", "Team_Name": "Ford", "Affiliation": "MLFB" }, { "Team": "GEI", "Team_Name": "Geis", "Affiliation": "MLFB" }, { "Team": "HAL", "Team_Name": "Hall", "Affiliation": "MLFB" }, { "Team": "KIR", "Team_Name": "Kirsey", "Affiliation": "MLFB" }, { "Team": "MIR", "Team_Name": "Miller", "Affiliation": "MLFB" }];

// const ifaObject: any = [{ "Team": "IFJJ", "Team_Name": "Ja Jalisco", "Affiliation": "IFA" }, { "Team": "IFCH", "Team_Name": "Chihuahua", "Affiliation": "IFA" }, { "Team": "IFCA", "Team_Name": "Cancunlisco", "Affiliation": "IFA" }, { "Team": "IFLV", "Team_Name": "Las Vegas", "Affiliation": "IFA" }, { "Team": "IFDA", "Team_Name": "Dallas", "Affiliation": "IFA" }, { "Team": "IFEL", "Team_Name": "El Paso", "Affiliation": "IFA" }];

// const ufl24Object: any = [
//     { "Team": "UFLAR", "Team_Name": "Dallas Renegades", "Affiliation": "UFL24" },
//     { "Team": "UFLDC", "Team_Name": "D.C. Defenders", "Affiliation": "UFL24" },
//     { "Team": "UFLHR", "Team_Name": "Houston Gamblers", "Affiliation": "UFL24" },
//     { "Team": "UFLMP", "Team_Name": "Z-Michigan Panthers", "Affiliation": "UFL24" },
//     { "Team": "UFLMS", "Team_Name": "Z-Memphis Showboats", "Affiliation": "UFL24" },
//     { "Team": "UFLSA", "Team_Name": "Z-San Antonio Brahmas", "Affiliation": "UFL24" },
//     { "Team": "UFLSB", "Team_Name": "St. Louis Battlehawks", "Affiliation": "UFL24" },
//     { "Team": "UFLBS", "Team_Name": "Birmingham Stallions", "Affiliation": "UFL24" },
// ].sort((a, b) => a.Team_Name.localeCompare(b.Team_Name));

// utils/loadFunctions.ts
export let ufl24Object: any = [];               // module-level cache
let ufl24Promise: Promise<any> | null = null;   // in-flight request guard

export function getUfl24Object() {
    return ufl24Object;
}

export function setUfl24Object(next: any) {
    ufl24Object = next;
    try { localStorage.setItem("ufl24Object", JSON.stringify(next)); } catch { }
}

/**
 * Loads UFL24 from server; falls back to localStorage while fetching.
 * Call on app mount (and after login if your API needs auth).
 */
export async function LoadUFL24(force = false): Promise<any> {
    if (!force && ufl24Promise) return ufl24Promise; // reuse in-flight
    ufl24Promise = (async () => {
        // Seed from cache/localStorage for instant availability
        if (!force && (!ufl24Object || (Array.isArray(ufl24Object) && ufl24Object.length === 0))) {
            try {
                const cached = localStorage.getItem("ufl24Object");
                if (cached) ufl24Object = JSON.parse(cached);
            } catch { }
        }

        // Fetch fresh
        const res = await fetch("https://www.fbxchange.com/ReactPHP/loadData.php", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams({ method: "getUFL24" }).toString(), // <-- match your PHP method name exactly
        });

        if (!res.ok) throw new Error(`LoadUFL24 failed: ${res.status}`);
        const data = await res.json();
        setUfl24Object(data);
        return data;
    })();

    try {
        return await ufl24Promise;
    } finally {
        // keep ufl24Promise for dedup across rapid calls; if you prefer single-shot, set to null here
        // ufl24Promise = null;
    }
}



export { cflObject };
export { nflObject };
export { eventSearch };
// export { ufl24Object };
export { usflObject };
export { xfl23Object };
export { xflObject };
export { aafObject };
export { mlfbObject };
export { uflObject };


const workingLeague = [
    { "League": "CFL", "Value": "CFL" },
    { "League": "NFL", "Value": "NFL" },
    { "League": "UFL24", "Value": "UFL24" },
    { "League": "Event", "Value": "EVENT" },
    { "League": "USFL", "Value": "USFL" },
    { "League": "XFL23", "Value": "XFL23" },
    { "League": "XFL", "Value": "XFL" },
    { "League": "AAF", "Value": "AAF" },
    { "League": "AFL", "Value": "AFL" },
    { "League": "MLFB", "Value": "MLFB" },
    { "League": "UFL", "Value": "UFL" },
    { "League": "USFL", "Value": "USFL" },
]

export { workingLeague }


const status: any = [{ "status_id": "DR", "status": "DRAFTED", "league": "UFL", "cflShow": "1" }, { "status_id": "NF", "status": "NON-FB INJURY", "league": "UFL", "cflShow": "1" }, { "status_id": "NO", "status": "NONE", "league": "UFL", "cflShow": "1" }, { "status_id": "O", "status": "OTHER RESERVE", "league": "UFL", "cflShow": "1" }, { "status_id": "PU", "status": "PHY UNABLE", "league": "UFL", "cflShow": "1" }, { "status_id": "NA", "status": "PRA ROSTER", "league": "UFL", "cflShow": "1" }, { "status_id": "PE", "status": "PRO EXEMPT", "league": "UFL", "cflShow": "1" }, { "status_id": "PL", "status": "PROTECTED LIST", "league": "UFL", "cflShow": "1" }, { "status_id": "RE", "status": "RESERVE", "league": "UFL", "cflShow": "1" }, { "status_id": "UN", "status": "UNSIGNED", "league": "UFL", "cflShow": "1" }, { "status_id": "SU", "status": "SUSPENDED", "league": "UFL", "cflShow": "1" }, { "status_id": "IA", "status": "NON-ACTIVE", "league": "UFL", "cflShow": "1" }, { "status_id": "LS", "status": "LEFT SQUAD", "league": "UFL", "cflShow": "1" }, { "status_id": "IP", "status": "IR in PRACTICE", "league": "UFL", "cflShow": "1" }, { "status_id": "AC", "status": "ACTIVE", "league": "UFL", "cflShow": "1" }, { "status_id": "RR", "status": "ACTIVE ALL", "league": "UFL", "cflShow": "1" }, { "status_id": "DE", "status": "DECEASED", "league": "UFL", "cflShow": "1" }, { "status_id": "DF", "status": "DEFERRED", "league": "UFL", "cflShow": "1" }, { "status_id": "DN", "status": "DID NOT REPORT", "league": "UFL", "cflShow": "1" }, { "status_id": "RT", "status": "RETIRED", "league": "UFL", "cflShow": "1" }, { "status_id": "DS", "status": "DISABLED", "league": "UFL", "cflShow": "1" }, { "status_id": "AX", "status": "ACTIVE Future", "league": "UFL", "cflShow": "1" }, { "status_id": "FA", "status": "FREE AGENT", "league": "UFL", "cflShow": "1" }, { "status_id": "IR", "status": "INJURED", "league": "UFL", "cflShow": "1" }, { "status_id": "TE", "status": "TERRITORIAL X", "league": "UFL", "cflShow": "1" }, { "status_id": "AC", "status": "ACTIVE", "league": "NFL", "cflShow": "1" }, { "status_id": "AC", "status": "ACTIVE", "league": "AAFB", "cflShow": "1" }, { "status_id": "AC", "status": "ACTIVE", "league": "CFL", "cflShow": "1" }, { "status_id": "AC", "status": "ACTIVE", "league": "AFL", "cflShow": "1" }, { "status_id": "AC", "status": "Active", "league": "MLFB", "cflShow": "1" }, { "status_id": "RR", "status": "ACTIVE ALL", "league": "AAFB", "cflShow": "1" }, { "status_id": "RR", "status": "Active All", "league": "MLFB", "cflShow": "1" }, { "status_id": "RR", "status": "ACTIVE ALL w/ NA", "league": "CFL", "cflShow": "1" }, { "status_id": "RR", "status": "ACTIVE ALL", "league": "NFL", "cflShow": "1" }, { "status_id": "RR", "status": "ACTIVE ALL", "league": "AFL", "cflShow": "1" }, { "status_id": "AX", "status": "ACTIVE Future", "league": "NFL", "cflShow": "1" }, { "status_id": "AX", "status": "ACTIVE Future", "league": "AAFB", "cflShow": "1" }, { "status_id": "BL", "status": "Bereavement Leave", "league": "MLFB", "cflShow": "1" }, { "status_id": "AX", "status": "ACTIVE Future", "league": "AFL", "cflShow": "1" }, { "status_id": "AA", "status": "ACTIVE ALL w/o NA or TE", "league": "CFL", "cflShow": "1" }, { "status_id": "FA", "status": "FREE AGENT", "league": "AFL", "cflShow": "1" }, { "status_id": "NA", "status": "PRACTICE SQUAD", "league": "NFL", "cflShow": "1" }, { "status_id": "AX", "status": "ACTIVE Future", "league": "CFL", "cflShow": "1" }, { "status_id": "DE", "status": "Deceased", "league": "MLFB", "cflShow": "1" }, { "status_id": "IR", "status": "INJURED", "league": "AFL", "cflShow": "1" }, { "status_id": "TR", "status": "NFL TRYOUT (Incl. Visits)", "league": "NFL", "cflShow": "1" }, { "status_id": "DR", "status": "DRAFTED", "league": "AAFB", "cflShow": "1" }, { "status_id": "NL", "status": "NEGLIST", "league": "CFL", "cflShow": "2" }, { "status_id": "FA", "status": "Free Agent", "league": "MLFB", "cflShow": "1" }, { "status_id": "VI", "status": "NFL VISIT (only)", "league": "NFL", "cflShow": "1" }, { "status_id": "RW", "status": "RECALLABLE", "league": "AFL", "cflShow": "1" }, { "status_id": "IP", "status": "Injured - Practice", "league": "MLFB", "cflShow": "1" }, { "status_id": "FA", "status": "FREE AGENT", "league": "AAFB", "cflShow": "1" }, { "status_id": "UN", "status": "...UNS Neg List", "league": "CFL", "cflShow": "1" }, { "status_id": "IR", "status": "INJURED", "league": "AAFB", "cflShow": "1" }, { "status_id": "IR", "status": "Injured - Reserve", "league": "MLFB", "cflShow": "1" }, { "status_id": "SU", "status": "SUSPENDED", "league": "AFL", "cflShow": "1" }, { "status_id": "MC", "status": "NFL MINI-CAMP Tryout", "league": "NFL", "cflShow": "1" }, { "status_id": "PN", "status": "...Public Neg List", "league": "CFL", "cflShow": "1" }, { "status_id": "DF", "status": "Other League Exempt", "league": "MLFB", "cflShow": "1" }, { "status_id": "RL", "status": "RIGHTS LIST", "league": "AAFB", "cflShow": "1" }, { "status_id": "FA", "status": "FREE AGENT", "league": "NFL", "cflShow": "1" }, { "status_id": "NP", "status": "...Neg List & Non-Active ", "league": "CFL", "cflShow": "2" }, { "status_id": "DF", "status": "OTHER LEAGUE EXEMPT", "league": "AFL", "cflShow": "1" }, { "status_id": "WC", "status": "Waived All Player Rights", "league": "AAFB", "cflShow": "1" }, { "status_id": "PU", "status": "PHYSICAL UNABLE", "league": "AFL", "cflShow": "1" }, { "status_id": "UP", "status": "...UNS Prac.Squad (FA)", "league": "NFL", "cflShow": "1" }, { "status_id": "FA", "status": "FREE AGENT", "league": "CFL", "cflShow": "1" }, { "status_id": "PU", "status": "Physically Unable", "league": "MLFB", "cflShow": "1" }, { "status_id": "TU", "status": "TENDERED/UNSIGNED", "league": "AAFB", "cflShow": "1" }, { "status_id": "NA", "status": "PRACTICE ROSTER", "league": "AAFB", "cflShow": "1" }, { "status_id": "UP", "status": "...UNS Non-Active(FA)", "league": "CFL", "cflShow": "1" }, { "status_id": "DN", "status": "REFUSE TO REPORT", "league": "AFL", "cflShow": "1" }, { "status_id": "WN", "status": "...Waived Non-FB Illness", "league": "NFL", "cflShow": "1" }, { "status_id": "DN", "status": "Refused to Report", "league": "MLFB", "cflShow": "1" }, { "status_id": "WF", "status": "...Waived Non-FB Injury", "league": "NFL", "cflShow": "1" }, { "status_id": "WI", "status": "...Waived Injured", "league": "NFL", "cflShow": "1" }, { "status_id": "IA", "status": "IN-ACTIVE", "league": "AFL", "cflShow": "1" }, { "status_id": "RT", "status": "Retired", "league": "MLFB", "cflShow": "1" }, { "status_id": "NA", "status": "NON-ACTIVE ROSTER", "league": "CFL", "cflShow": "1" }, { "status_id": "NP", "status": "...Non-Active & Neg List", "league": "CFL", "cflShow": "2" }, { "status_id": "DS", "status": "DISABLED", "league": "AFL", "cflShow": "1" }, { "status_id": "LS", "status": "Suspension - League", "league": "MLFB", "cflShow": "1" }, { "status_id": "IR", "status": "INJURED", "league": "NFL", "cflShow": "1" }, { "status_id": "LS", "status": "LEFT SQUAD", "league": "AFL", "cflShow": "1" }, { "status_id": "IR", "status": "INJURED - 1 Game (+6 Gm)", "league": "CFL", "cflShow": "1" }, { "status_id": "SU", "status": "Suspension - Team", "league": "MLFB", "cflShow": "1" }, { "status_id": "IP", "status": "...INJURED Practice Squad", "league": "NFL", "cflShow": "1" }, { "status_id": "I6", "status": "INJURED - 6 Game", "league": "CFL", "cflShow": "1" }, { "status_id": "DE", "status": "DECEASED", "league": "AFL", "cflShow": "1" }, { "status_id": "RE", "status": "Inactive Reserve", "league": "MLFB", "cflShow": "1" }, { "status_id": "DR", "status": "DRAFTED", "league": "NFL", "cflShow": "1" }, { "status_id": "DR", "status": "Drafted", "league": "MLFB", "cflShow": "1" }, { "status_id": "WD", "status": "...Waived Draft Rights", "league": "NFL", "cflShow": "1" }, { "status_id": "SU", "status": "SUSPENDED", "league": "CFL", "cflShow": "1" }, { "status_id": "DW", "status": "...DRAFTED - UNS XFL", "league": "NFL", "cflShow": "1" }, { "status_id": "DR", "status": "DRAFTED", "league": "AFL", "cflShow": "1" }, { "status_id": "NF", "status": "NON-FB Injury", "league": "AAFB", "cflShow": "1" }, { "status_id": "RL", "status": "RIGHTS List", "league": "XFL", "cflShow": "1" }, { "status_id": "RL", "status": "RIGHTS List", "league": "NFL", "cflShow": "1" }, { "status_id": "IA", "status": "NON-ACTIVE", "league": "AAFB", "cflShow": "1" }, { "status_id": "EX", "status": "EXEMPT", "league": "NFL", "cflShow": "1" }, { "status_id": "IP", "status": "INJURED PRACTICE", "league": "AFL", "cflShow": "1" }, { "status_id": "N", "status": "NOTES: History ONLY", "league": "NFL", "cflShow": "1" }, { "status_id": "NI", "status": "NON-FB Illness", "league": "AAFB", "cflShow": "1" }, { "status_id": "DR", "status": "DRAFTED", "league": "CFL", "cflShow": "1" }, { "status_id": "TE", "status": "TERRITORIAL Exempt", "league": "CFL", "cflShow": "1" }, { "status_id": "PU", "status": "PHYSICAL UNABLE", "league": "AAFB", "cflShow": "1" }, { "status_id": "NA", "status": "PRA ROSTER", "league": "AFL", "cflShow": "1" }, { "status_id": "O", "status": "Reserves: ALL Categories", "league": "NFL", "cflShow": "1" }, { "status_id": "DN", "status": "DID NOT REPORT", "league": "AAFB", "cflShow": "1" }, { "status_id": "PU", "status": "Reserve: PHYSICAL UNABLE", "league": "NFL", "cflShow": "1" }, { "status_id": "NF", "status": "NON-FB INJURY", "league": "AFL", "cflShow": "1" }, { "status_id": "UT", "status": "...Unsigned TERRITORIAL", "league": "CFL", "cflShow": "1" }, { "status_id": "SU", "status": "SUSPENDED", "league": "AAFB", "cflShow": "1" }, { "status_id": "NO", "status": "NONE", "league": "AFL", "cflShow": "1" }, { "status_id": "N", "status": "Notes: History Only", "league": "CFL", "cflShow": "1" }, { "status_id": "DN", "status": "Reserve: DID NOT REPORT", "league": "NFL", "cflShow": "1" }, { "status_id": "RT", "status": "RETIRED", "league": "CFL", "cflShow": "1" }, { "status_id": "DS", "status": "DISABLED", "league": "AAFB", "cflShow": "1" }, { "status_id": "O", "status": "OTHER RESERVE", "league": "AFL", "cflShow": "1" }, { "status_id": "SU", "status": "Reserve: SUSPENDED", "league": "NFL", "cflShow": "1" }, { "status_id": "DF", "status": "Deferred", "league": "CFL", "cflShow": "1" }, { "status_id": "PE", "status": "PENSION", "league": "AFL", "cflShow": "1" }, { "status_id": "DS", "status": "Reserve: DISABLED", "league": "NFL", "cflShow": "1" }, { "status_id": "DN", "status": "Did Not Report", "league": "CFL", "cflShow": "1" }, { "status_id": "RE", "status": "RESERVE", "league": "AFL", "cflShow": "1" }, { "status_id": "RT", "status": "RETIRED", "league": "AAFB", "cflShow": "1" }, { "status_id": "LS", "status": "Reserve: LEFT SQUAD", "league": "NFL", "cflShow": "1" }, { "status_id": "EX", "status": "EXEMPT", "league": "AAFB", "cflShow": "1" }, { "status_id": "DS", "status": "Disabled", "league": "CFL", "cflShow": "1" }, { "status_id": "RT", "status": "RETIRED", "league": "AFL", "cflShow": "1" }, { "status_id": "PU", "status": "Physical Unable", "league": "CFL", "cflShow": "1" }, { "status_id": "TL", "status": "TERMINATED", "league": "AFL", "cflShow": "1" }, { "status_id": "RE", "status": "Reserve-2 Man", "league": "CFL", "cflShow": "1" }, { "status_id": "RE", "status": "Reserve", "league": "AAFB", "cflShow": "1" }, { "status_id": "TF", "status": "In Transit", "league": "CFL", "cflShow": "1" }, { "status_id": "DE", "status": "Deceased", "league": "CFL", "cflShow": "1" }, { "status_id": "LS", "status": "LEFT SQUAD", "league": "AAFB", "cflShow": "1" }, { "status_id": "DE", "status": "DECEASED", "league": "AAFB", "cflShow": "1" }, { "status_id": "RW", "status": "Recalled from Waiver", "league": "CFL", "cflShow": "1" }, { "status_id": "DF", "status": "Reserve/OTHER LEAGUE", "league": "AAFB", "cflShow": "1" }, { "status_id": "IA", "status": "Reserve-INACTIVE", "league": "NFL", "cflShow": "1" }, { "status_id": "RE", "status": "Reserve: Other League", "league": "NFL", "cflShow": "1" }, { "status_id": "RT", "status": "Reserve: RETIRED", "league": "NFL", "cflShow": "1" }, { "status_id": "NF", "status": "Reserve: NON-FB INJURY", "league": "NFL", "cflShow": "1" }, { "status_id": "CA", "status": "Reserve: COVID-19", "league": "NFL", "cflShow": "1" }, { "status_id": "CP", "status": "...Reserve: PRA.SQD C-19", "league": "NFL", "cflShow": "1" }, { "status_id": "OO", "status": "Reserve: OPT OUT", "league": "NFL", "cflShow": "1" }, { "status_id": "NI", "status": "Reserve: NON-FB ILLNESS", "league": "NFL", "cflShow": "1" }, { "status_id": "NO", "status": "Note - History ONLY", "league": "NFL", "cflShow": "1" }, { "status_id": "PE", "status": "Pension", "league": "NFL", "cflShow": "1" }, { "status_id": "DF", "status": "DEFERRED", "league": "NFL", "cflShow": "1" }, { "status_id": "RE", "status": "Reserve/Other League", "league": "XFL", "cflShow": "1" }, { "status_id": "DE", "status": "DECEASED", "league": "NFL", "cflShow": "1" }]

type StatusItem = {
    status_id: string;
    status: string;
    league: string;
    cflShow: string;
};

const filterStatusByLeague = (league: string, statusList: StatusItem[] = status) =>
    statusList
        .filter((item: StatusItem) => item.league === league)
        .map((item: StatusItem) => ({
            status_id: item.status_id,
            status: item.status,
            cflShow: item.cflShow,
        }));

const NFLStatus = filterStatusByLeague("NFL");
const CFLStatus = filterStatusByLeague("CFL");

export { NFLStatus }
export { CFLStatus }

let statusPromise: Promise<any> | null = null;

const setLeagueStatus = (leagueStatus: any[], nextStatus: any[]) => {
    leagueStatus.splice(0, leagueStatus.length, ...nextStatus);
};

export const LoadStatuses = async (force = false): Promise<any> => {
    if (!force && statusPromise) return statusPromise;

    statusPromise = (async () => {
        const res = await fetch("https://www.fbxchange.com/ReactPHP/loadData.php", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams({ method: "getStatusdata" }).toString(),
        });

        if (!res.ok) throw new Error(`LoadStatuses failed: ${res.status}`);
        const data = await res.json();
        const liveStatus = Array.isArray(data) ? data : [];

        setLeagueStatus(CFLStatus, filterStatusByLeague("CFL", liveStatus));
        setLeagueStatus(NFLStatus, filterStatusByLeague("NFL", liveStatus));

        return liveStatus;
    })();

    return statusPromise;
};


const startValues = {
    Conference: "-",
    LAST: "",
    FIRST: "",
    COL_POS1: "-",
    GENPOS: "-",
    CFL_DRAFT_YEAR: "",
    HSstars: "-",
    HSstars_TO: "-",
    SCHOOL: "-",
    PLAYER_POS: "-",
    NFLTEAM: "-",
    CFLTEAM: "-",
    UFL24TEAM: "-",
    HEIGHT: "-",
    HEIGHT_TO: "-",
    WEIGHT: "",
    WEIGHT_TO: "",
    SPEED40FASTEST: "",
    SPEED40FASTEST_TO: "",
    AGENTNUM: "-",
    COUNTRY: "-",
    STATE: "-",
    HOMESTATE: '-',
    DRAFT_ROUND: "",
    DRAFT_PICK: "",
    DRAFT_STATUS: "-",
    SCHOOL_COUNTRY: "-",
    LAST_SCHOOL: "-",
    LAST_SCHOOL_TWO: "-",
    IMPNIP: "-",
    OPTION_YR: "",
    CFLSTATUS: "-",
    NFLSTATUS: "-",
    UFL24STATUS: "-",
    HS_POSITION: "-",
    rateAll: "",
    rateAll_TO: "",
    CFL_DRAFT_ROUND: "",
    CFL_DRAFT_ROUND_TO: "",
    CFL_DRAFT_YEAR_TO: "",
    DRAFT_YEAR: "",
    NFL_DRAFT_YEAR: "",
    NFL_DRAFT_YEAR_TO: "",
    NFL_DRAFT_ROUND: "",
    NFL_DRAFT_ROUND_TO: "",
    schoolCountry: '-',
    CFLPos: '-',
    CFLGP: '-',
    NFLPos: '-',
    NFLGP: '-',
    UFL24Pos: '-',
    UFL24GP: '-',
    Country: '-',
    playerCountryCode: '-',
    CFLStatusDateStart: null,
    CFLStatusDateEnd: null,
    NFLStatusDateStart: null,
    NFLStatusDateEnd: null,
    UFL24StatusDateStart: null,
    UFL24StatusDateEnd: null,
}

export { startValues }

export const FindCFLTeam = (league: string, code: string): string => {
    let theLeague: any[] = []; // Initialize as an empty array
    switch (league.toLowerCase()) { // Use case-insensitive comparison
        case 'cfl':
            theLeague = cflObject;
            break;
        case 'nfl':
            theLeague = nflObject;
            break;
        case 'ufl':
            theLeague = ufl24Object;
            break;
        case 'event':
            theLeague = eventSearch;
            break;
        default:
            return 'Unknown League'; // Fallback for unsupported leagues
    }

    const teamRecord = theLeague.find(item => item.Team === code);
    if (teamRecord) {
        return teamRecord ? teamRecord.Team_Name : 'Unknown Team'; // Handle case where teamRecord is undefined
    } else
        return '';

};


export const FindStatus = (league: string, code: string): string => {
    let theLeague: any[] = [];
    switch (league.toLowerCase()) { // Use case-insensitive comparison
        case 'cfl':
            theLeague = CFLStatus
            break;
        case 'nfl':
            theLeague = NFLStatus
            break;
        case 'ufl':
            theLeague = NFLStatus
            break;
        case 'event':
            theLeague = NFLStatus
            break;
        // Add more leagues as needed
        default:
            return 'Unknown League'; // Fallback for unsupported leagues
    }
    const teamRecord = theLeague.find(item => item.status_id === code);

    if (teamRecord) {
        return teamRecord.status || ''; // Return status or an empty string if undefined
    } else {
        return ''; // Return an empty string if no match is found
    }
};

export const runAlertSearch = async (inval: string, alertType: string = 'Transactions') => {
    const user = await getUserFromToken();
    if (!user) return;
    try {
        const response = await fetch('https://www.fbxchange.com/ReactPHP/AlertSearch.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                method: 'getTransDataFBX',
                scout: user.scout,
                team: user.team,
                timePeriod: inval,
                alertType,
            }).toString()
        });

        const data = await response.json();

        return data;

    } catch (error) {
        console.error('Failed to fetch token:', error);
        return null; // Return null in case of an error
    }
}

export const runAlertDate = async (start: string, end: string, alertType: string = 'Transactions') => {
    const user = await getUserFromToken();
    if (!user) return;
    try {
        const response = await fetch('https://www.fbxchange.com/ReactPHP/AlertSearch.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                method: 'searchByDate',
                scout: user.scout,
                team: user.team,
                start: start,
                end: end,
                alertType,
            }).toString()
        });

        const data = await response.json();

        return data;

    } catch (error) {
        console.error('Failed to fetch token:', error);
        return null; // Return null in case of an error
    }
}
